/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateDefaultInstrumentRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/UpdateDefaultInstrument.pb'
import {UpdateDefaultInstrumentResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/UpdateDefaultInstrument.pb'


export const updateDefaultInstrument = (request: UpdateDefaultInstrumentRequest, options?: CashRequestOptions) => post<UpdateDefaultInstrumentRequest, UpdateDefaultInstrumentResponse>("/2.0/cash/update-default-instrument", request, {...options, rejectOnError: true })